import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  OnChanges,
  OnDestroy,
} from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { OrderNotes } from "../../../core/models/invoice-preview/orderNotes";
import { InvoicePreviewDetailDto } from "../../../core/models/invoice-preview/InvoicePreviewDetailDto";
import { InvoicePreviewLinesDto } from "../../../core/models/invoice-preview/invoicePreviewLinesDto";
import { TrackingFreightApiRequestDto } from "../../../core/models/invoice-preview/trackingFreightApiRequestDto";
import { ActivatedRoute } from "@angular/router";
import { FreightTrackingsDetailValue } from "../../../core/models/invoice-preview/FreightTrackingsDetailValue";
import { InvoicePreviewOrderLineDetailsService } from "../../../core/services/invoice-preview-order-line-details.service";
import { distinctUntilChanged } from "rxjs";
import { InvoicePreviewInvoiceEmailsComponent } from "../invoice-preview-invoice-emails/invoice-preview-invoice-emails.component";
import { OrderNotesSidebarComponent } from "../../orders/components/order-notes-sidebar/order-notes-sidebar.component";
import { InvoicePreviewOrderNotesComponent } from "../invoice-preview-order-notes/invoice-preview-order-notes.component";
import { v4 as uuidv4 } from "uuid";
import { ProjectInvoicePrintPreviewReportRequestDto } from "../../../core/models/invoice-preview/projectInvoicePrintPreviewReportRequestDto";
import { UpdateInvoicePreviewStatusDto } from "../../../core/models/invoice-preview/updateInvoicePreviewStatusDto";
import { ApprovalStatus } from "../../../core/models/invoice-preview/approvalStatus";
import { GetBillingDetailsForEmailsDto } from "../../../core/models/invoice-preview/getBillingDetailsForEmailsDto";
import * as MicrosoftGraph from "@microsoft/microsoft-graph-types";
import { InvoicePreviewLines } from "../../../core/models/invoice-preview/InvoicePreviewLines";
import { InvoicePreviewOrderTrackingComponent } from "../invoice-preview-order-tracking/invoice-preview-order-tracking.component";
import { InvoiceEmail } from "../../../core/models/orders/invoicedEmail";
import { PrintPurchaseOrderDto } from "../../../core/models/orders/purchaseOrderLine";
import { SalesOrderNotes } from "../../../core/models/orders/salesOrderNotes";
import { VendorInvoiceJournalDetailValue } from "../../../core/models/orders/vendorInvoiceJournalDetailValue";
import { GetUserDto } from "../../../core/models/users/users/getUserDto";
import { InvoicePreviewSummaryService } from "../../../core/services/invoice-preview-summary.service";
import { LoaderService } from "../../../core/services/loader.service";
import { OrderSummaryService } from "../../../core/services/order-summary.service";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { MsalApiService } from "../../../core/services/msal-api.service";
import { SidebarService } from "../../../core/services/sidebar.service";
import { CommonModule } from "@angular/common";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { CheckboxChangeEvent, CheckboxModule } from "primeng/checkbox";
import { FormsModule } from "@angular/forms";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { RadioButtonModule } from "primeng/radiobutton";
import { PanelModule } from "primeng/panel";
import { UpdateProjectInvoicePreviewStatusResponseDto } from "../../../core/models/invoice-preview/updateProjectInvoicePreviewStatusResponseDto";
import { InvoicePreviewOrderLineDetailsComponent } from "../invoice-preview-order-line-details/invoice-preview-order-line-details.component";
import { PrintPurchaseOrderComponent } from "../../orders/components/print-purchase-order/print-purchase-order.component";
import { InvoicePreviewOrderDetailsComponent } from "../invoice-preview-order-details/invoice-preview-order-details.component";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { ToggleSwitchModule } from "primeng/toggleswitch";

@UntilDestroy()
@Component({
  selector: "jni-invoice-preview-summary",
  templateUrl: "./invoice-preview-summary.component.html",
  styleUrls: ["./invoice-preview-summary.component.scss"],
  imports: [
    CommonModule,
    SelectModule,
    CheckboxModule,
    FormsModule,
    ModalStackerComponent,
    NgxExtendedPdfViewerModule,
    RadioButtonModule,
    PanelModule,
    OrderNotesSidebarComponent,
    InvoicePreviewOrderLineDetailsComponent,
    InvoicePreviewOrderTrackingComponent,
    PrintPurchaseOrderComponent,
    InvoicePreviewInvoiceEmailsComponent,
    InvoicePreviewOrderNotesComponent,
    InvoicePreviewOrderDetailsComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
    ToggleSwitchModule,
  ],
})
export class InvoicePreviewSummaryComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() invoicePreviewNumber = "";
  @Input() saleOrderId = "";
  @Input() invoicePreviewNumberFromModal = "";
  @Output() scrollHiddenStatus = new EventEmitter();
  @Input() selectedRadioButton = "";
  @Output() closeModalEvent = new EventEmitter();
  copyBacEmail = "";
  copyBcEmail = "";
  copyBcName = "";
  copyBacName = "";
  copyEmail = "";
  copyName = "";
  defaultTracking = "3";
  defaultLine = 0;
  reportBase64String = "";
  quickQuote = "";
  salesId = "";
  projId = "";
  customerPONumber = "";
  jobName = "";
  shippingMethodCode = "";
  updateIpStatus = true;
  isCollapsed = false;
  vendorInvoiceJournalDetail: VendorInvoiceJournalDetailValue[] = [];
  unmatchQuantityStatus = false;
  pdfZoom = "60";
  includeNetOnlyToggle = false;
  invoicePreviewStatus: ApprovalStatus[] = [
    {
      id: "Open",
      name: "Open",
    },
    {
      id: "Approved",
      name: "Approved",
    },
    {
      id: "ApproveSplitPending",
      name: "Approve Split Pending",
    },
    {
      id: "WrongCosts",
      name: "Wrong Costs",
    },
    {
      id: "WrongSell",
      name: "Wrong Sell",
    },
    {
      id: "WrongTax",
      name: "Wrong Tax",
    },
    {
      id: "WrongFreight",
      name: "Wrong Freight",
    },
    {
      id: "WrongOther",
      name: "Wrong Other",
    },
  ];

  defaultInvoicePreviewStatus = "Open";
  displaySideBeforeSubmittingStatus = false;
  showPdfViewer = false;
  printPdfModal = false;
  openPrinfPdfFlag = false;
  invoicePreviewModalStatus = false;
  orderTrackingModalStatus = false;
  orderLinesDetailModalStatus = false;

  orderNotesGridListing: OrderNotes[] = [];
  orderLineDetailsGridListing: InvoicePreviewLinesDto[] = [];
  orderLineDetailsGridListingAllData: InvoicePreviewLinesDto[] = [];
  orderLineDetailsGridListingFilters: InvoicePreviewLinesDto[] = [];
  invoicePreviewLines: InvoicePreviewLines = {} as InvoicePreviewLines;
  orderTrackingGridListing: FreightTrackingsDetailValue[] = [];
  invoiceEmailListing: InvoiceEmail[] = [];
  invoicePreviewSummary!: InvoicePreviewDetailDto;
  purchaseOrderLine: PrintPurchaseOrderDto[] = [];

  billingDetailsForEmails: GetBillingDetailsForEmailsDto =
    {} as GetBillingDetailsForEmailsDto;

  userInfo: GetUserDto = {} as GetUserDto;

  collapseNotesStatus = true;
  expandNotesStatus = false;
  collapseNotesHeading = "Expand all";

  collapseOrderLineDetailsStatus = true;
  expandOrderLineDetailsStatus = false;
  collapseOrderLineDetailsHeading = "Expand all";

  collapseOrderTrackingStatus = true;
  expandOrderTrackingStatus = false;
  collapseOrderTrackingHeading = "Expand all";

  collapseInvoiceEmailStatus = false;
  expandInvoiceEmailStatus = false;
  collapseInvoiceEmailHeading = "Expand all";
  clientName = "";
  approvalStatus = "";
  freightChargesDisplayModal = false;
  showLessOrderLinesSection = false;

  @ViewChild("invoiceEmail", { static: false })
  invoiceEmail!: InvoicePreviewInvoiceEmailsComponent;

  @ViewChild("ordernotessidebar", { static: false })
  ordernotessidebar!: OrderNotesSidebarComponent;

  @ViewChild("ordernotes", { static: false })
  ordernotes!: InvoicePreviewOrderNotesComponent;

  @ViewChild("orderTracking", { static: false })
  orderTracking!: InvoicePreviewOrderTrackingComponent;

  orderLineDetailsConsumesMessage = "Please wait loading lines";

  constructor(
    private _invoicePreviewSummaryService: InvoicePreviewSummaryService,
    private _loaderService: LoaderService,
    private _toastrService: JniToastrService,
    private _activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    private _invoicePreviewOrderLineDetailsService: InvoicePreviewOrderLineDetailsService,
    private _orderSummaryService: OrderSummaryService,
    private _msalApisService: MsalApiService,
    private _dataService: SidebarService
  ) {
    this._activatedRoute.params.subscribe(
      params => (this.invoicePreviewNumber = params["id"])
    );
  }

  ngOnInit(): void {
    this.getInvoicePreviewSummary(this.invoicePreviewNumber);
    this.getOrderLineDetails(this.invoicePreviewNumber);
    this.getOrderTracking(this.invoicePreviewNumber);
    this.getOrderTrackingData();
    this.getNotesStateOfCollapseAll();
    this.getOrderLineDetailsStateOfCollapseAll();
    this.getOrderTrackingStateOfCollapseAll();
    this.getInvoiceEmailStateOfCollapseAll();
    this.getMyProfile();
    if (window.outerWidth < 1400) {
      this.pdfZoom = "50";
    }
    // Make Preview button on and collaspe the left menu bar
    this.showPdfViewer = true;
    this._dataService.setSidebarState(!this.isCollapsed);
  }

  ngOnChanges(): void {
    if (this.invoicePreviewNumberFromModal) {
      this.invoicePreviewNumber = this.invoicePreviewNumberFromModal;
      this.invoicePreviewModalStatus = true;
    }
  }

  getOrderTrackingData() {
    this._loaderService.setLoaderState(true);
    this._invoicePreviewOrderLineDetailsService.selectedSalesId$
      .pipe(distinctUntilChanged(), untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res) {
            this.getOrderTrackingDataAgainstSaleOrder(res.SalesId, res.ProjId);
          }
          this._loaderService.setLoaderState(false);
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getInvoicePreviewSummary(invoicePreviewNumber: string) {
    if (this.updateIpStatus) {
      this._loaderService.setLoaderState(true);
    }
    this._invoicePreviewSummaryService
      .getInvoicePreviewSummary(invoicePreviewNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.invoicePreviewSummary = res.data;
            this.customerPONumber = res.data.clientPO;
            this.jobName = res.data.jobName || "";
            this.shippingMethodCode = res.data.freightMethodCode;
            this.clientName = res.data.customer;
            this.approvalStatus = res.data.status;
            this.getProjectInvoicePrintPreviewReport(res.data.proposalRecId);
            this.patchValueInApprovalStatus(res.data.status);
            if (res.data.orderNumber) {
              this.getInvoiceEmail(this.saleOrderId);
            }
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  patchValueInApprovalStatus(approvalStatus: string) {
    // if (approvalStatus?.toLowerCase()?.includes('approvepending')) {
    //   this.defaultInvoicePreviewStatus = 'Approve-Split-Pending';
    // } else if (approvalStatus?.toLowerCase()?.includes('costs')) {
    //   this.defaultInvoicePreviewStatus = 'Wrong Costs';
    // } else if (approvalStatus?.toLowerCase()?.includes('sell')) {
    //   this.defaultInvoicePreviewStatus = 'Wrong Sell';
    // } else if (approvalStatus?.toLowerCase()?.includes('tax')) {
    //   this.defaultInvoicePreviewStatus = 'Wrong Tax';
    // } else if (approvalStatus?.toLowerCase()?.includes('freight')) {
    //   this.defaultInvoicePreviewStatus = 'Wrong Freight';
    // } else if (approvalStatus?.toLowerCase()?.includes('other')) {
    //   this.defaultInvoicePreviewStatus = 'Wrong Other';
    // } else {
    //   this.defaultInvoicePreviewStatus = approvalStatus;
    // }
    this.defaultInvoicePreviewStatus = approvalStatus;
  }

  getSalesOrderNotes(saleOrderId: string) {
    this._loaderService.setLoaderState(true);
    this._invoicePreviewSummaryService
      .getSalesOrderNotes(saleOrderId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.orderNotesGridListing = res.data;
            if (this.orderNotesGridListing?.length > 0) {
              this.expandNotesStatus = false;
              this.onNotesToggle();
            } else {
              this.expandNotesStatus = true;
              this.onNotesToggle();
            }
            this.ordernotes.getAllLinePoNumber(this.saleOrderId);
          } else {
            this.expandNotesStatus = true;
            this.onNotesToggle();
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getOrderLineDetails(invoicePreviewNumber: string) {
    this._loaderService.setLoaderState(true);
    this._invoicePreviewSummaryService
      .getOrderLineDetails(invoicePreviewNumber, this.defaultLine)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.invoicePreviewLines = res.data;
            if (
              this.invoicePreviewLines?.invoicePreviewLinesDto &&
              this.invoicePreviewLines?.invoicePreviewLinesDto?.length > 0
            ) {
              this.orderLineDetailsGridListingAllData =
                this.invoicePreviewLines.invoicePreviewLinesDto ?? null;
              if (this.orderLineDetailsGridListingAllData.length > 12)
                this.orderLineDetailsGridListing =
                  this.orderLineDetailsGridListingAllData.slice(0, 12);
              else {
                this.orderLineDetailsGridListing =
                  this.orderLineDetailsGridListingAllData;
              }
              this.orderLineDetailsGridListingFilters =
                this.orderLineDetailsGridListing;
            } else {
              this.orderLineDetailsConsumesMessage = "No order line found.";
            }

            for (const item of this.orderLineDetailsGridListing) {
              if (item.salesId) {
                this.saleOrderId = item.salesId;
                this.getSalesOrderNotes(this.saleOrderId);
                this._invoicePreviewOrderLineDetailsService.onSalesIdSelection({
                  SalesId: this.saleOrderId,
                  ProjId: item.projId,
                });
                break;
              }
            }
            this.includeNetOnlyLines({ checked: this.includeNetOnlyToggle });
          } else {
            this.orderLineDetailsConsumesMessage = "No order line found.";
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this.orderLineDetailsConsumesMessage =
            "There is some error while fetching records.";
        },
      });
  }

  printPdfByPurchaseOrderId(purchaseOrderId: string) {
    this._loaderService.setLoaderState(true);
    this._orderSummaryService.printPOForSalesOrder(purchaseOrderId).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.reportBase64String = res.data;
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  onPdfView() {
    if (this.reportBase64String) {
      const blob = this.b64toBlob(this.reportBase64String, "application/pdf");
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl);
    }
  }

  getProjectInvoicePrintPreviewReport(proposalRecId: number) {
    if (this.updateIpStatus) {
      this._loaderService.setLoaderState(true);
    }
    const reportObject = {
      ProjProposalRecId: proposalRecId,
    } as ProjectInvoicePrintPreviewReportRequestDto;

    this._invoicePreviewSummaryService
      .GetProjectInvoicePrintPreviewReport(reportObject)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.reportBase64String = res.data.reportBase64String;
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  updateCustomerPONumber(updateCustomerPONumber: string) {
    this.customerPONumber = updateCustomerPONumber;
    this.tabOutEventUpdateStatus();
  }

  updateJobNameEvent(updateJobName: string) {
    this.jobName = updateJobName;
    this.tabOutEventUpdateStatus();
  }

  updateShippingMethodEvent(shippingMethodCode: string) {
    this.shippingMethodCode = shippingMethodCode;
    this.tabOutEventUpdateStatus();
  }

  tabOutEventUpdateStatus() {
    this.updateIpStatus = false;
    this.updateInvoicePreviewStatusApprovalCall();
  }

  onApprovalSelection(approvalStatus: SelectChangeEvent) {
    this.defaultInvoicePreviewStatus = approvalStatus.value;
  }

  openSideBarForOrderNotesBeforeSubmittingStatus() {
    this.displaySidebar = true;
    this.displaySideBeforeSubmittingStatus = true;
    this.ordernotessidebar.getAllLinePoNumber(this.saleOrderId);
    this.ordernotessidebar?.clearOrderNoteForm();
  }

  updateInvoicePreviewStatus() {
    this.updateIpStatus = true;
    if (this.defaultInvoicePreviewStatus?.toLowerCase().includes("wrong")) {
      this.openSideBarForOrderNotesBeforeSubmittingStatus();
      return;
    }

    this.updateInvoicePreviewStatusApprovalCall();
  }

  closeSidebarAndCallStatusApprovalCall() {
    this.updateInvoicePreviewStatusApprovalCall();
  }

  updateInvoicePreviewStatusApprovalCall() {
    if (this.updateIpStatus) {
      this._loaderService.setLoaderState(true);
    }

    const invoicePreviewStatusObject = {
      proposalId: this.invoicePreviewNumber,
      approvalStatus: this.defaultInvoicePreviewStatus,
      customerPurchaseOrderNumber: this.customerPONumber,
      jobName: this.jobName,
      freightMethod: this.shippingMethodCode,
      updateIpStatus: this.updateIpStatus,
    } as UpdateInvoicePreviewStatusDto;
    this._invoicePreviewSummaryService
      .UpdateInvoicePreviewStatus(invoicePreviewStatusObject)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data.Status.toLowerCase() === "success") {
            this._toastrService.success(
              "Success",
              !this.updateIpStatus
                ? `Update successfully`
                : res.message || `Approval status update successfully`
            );

            //Send email directly to the user who created the IP
            if (
              invoicePreviewStatusObject.updateIpStatus === true &&
              (res?.data?.ApprovalStatus?.toLocaleLowerCase() === "approved" ||
                res?.data?.ApprovalStatus?.toLocaleLowerCase() ===
                  "approvesplitpending")
            ) {
              this.sendApprovalStatusEmailIfApproved(res.data);
              this.getSalesOrderNotes(this.saleOrderId);
            } else if (invoicePreviewStatusObject.updateIpStatus === true) {
              this.getBillingDetailsForEmails(this.invoicePreviewNumber);
            }
            this.getInvoicePreviewSummary(this.invoicePreviewNumber);
          } else {
            this._toastrService.error(
              "Error",
              !this.updateIpStatus
                ? `Error while updating`
                : res?.message || `Error updating approval status`
            );
          }
        },
        error: () => {
          this._toastrService.error(
            "Error",
            !this.updateIpStatus
              ? `Error while updating`
              : `Error updating approval status`
          );
          this._loaderService.setLoaderState(false);
        },
      });
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  vendorInvoiceSelection() {
    for (const item of this.purchaseOrderLine) {
      this.openPdfScreen(item?.purchaseOrderNumber || "");
    }
  }

  openPdfScreen(purchaseOrderId: string) {
    const url = `/orders/po-email/${this.saleOrderId}/${purchaseOrderId}`;
    window.open(url, "_blank");
  }

  getPurchaseOrderLine() {
    this._loaderService.setLoaderState(true);
    this._invoicePreviewSummaryService
      .getPurchaseOrderLine(this.saleOrderId)
      .subscribe({
        next: res => {
          if (res.data) {
            this.purchaseOrderLine = res.data;
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getOrderTracking(invoiceProposalId: string) {
    // const localCacheOrderTracking = localStorage.getItem('order-tracking');
    // if (localCacheOrderTracking) {
    //   const parsedOrderTracking = JSON.parse(localCacheOrderTracking);
    //   if (
    //     parsedOrderTracking &&
    //     parsedOrderTracking?.InvoiceProposalId == invoiceProposalId
    //   ) {
    //     this.orderTrackingGridListing =
    //       parsedOrderTracking?.AllFreightTrackingLines || [];
    //   }
    // } else {
    const payload = {
      ProposalId: invoiceProposalId,
    } as TrackingFreightApiRequestDto;
    this._invoicePreviewSummaryService
      .getOrderTracking(payload)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data?.AllFreightTrackingLines) {
            const orderTracking = {
              ...res.data,
              InvoiceProposalId: invoiceProposalId,
            };
            localStorage.setItem(
              "order-tracking",
              JSON.stringify(orderTracking)
            );
            this.orderTrackingGridListing = res.data.AllFreightTrackingLines;
          }
        },
        error: res => {
          this._toastrService.error(
            "Error",
            res.message || "Error In Fetching Freight Details From D365"
          );
        },
      });
    // }
  }

  getInvoiceEmail(saleOrderId: string) {
    this.invoiceEmailListing = [];
    if (this.updateIpStatus) {
      this._loaderService.setLoaderState(true);
    }
    this._invoicePreviewSummaryService
      .getInvoiceEmail(saleOrderId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            if (res.data) {
              if (res.data.length > 0) {
                res.data.forEach(x => {
                  if (x.invoice) {
                    this.invoiceEmailListing.push(x);
                  }
                });
              }
            }
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  onNotesToggle() {
    if (this.expandNotesStatus) {
      this.collapseNotesStatus = true;
      this.expandNotesStatus = false;
      //this.setNotesStateOfExpandAll();
      this.collapseNotesHeading = "Expand all";
    } else {
      this.collapseNotesStatus = false;
      this.expandNotesStatus = true;
      //this.setNotesStateOfCollapseAll();
      this.collapseNotesHeading = "Collapse all";
    }
  }

  setNotesStateOfExpandAll() {
    localStorage.setItem("Invoice-Preview-Notes-collapse", "true");
  }

  setNotesStateOfCollapseAll() {
    localStorage.setItem("Invoice-Preview-Notes-collapse", "false");
  }

  getNotesStateOfCollapseAll() {
    const status = localStorage.getItem("Invoice-Preview-Notes-collapse");
    if (status) {
      if (status === "true") {
        this.collapseNotesStatus = true;
        this.expandNotesStatus = false;
        this.collapseNotesHeading = "Expand all";
      } else {
        this.collapseNotesStatus = false;
        this.expandNotesStatus = true;
        this.collapseNotesHeading = "Collapse all";
      }
    }
  }

  onOrderLineDetailsToggle() {
    if (this.expandOrderLineDetailsStatus) {
      this.collapseOrderLineDetailsStatus = true;
      this.expandOrderLineDetailsStatus = false;
      this.setOrderLineDetailsStateOfExpandAll();
      this.collapseOrderLineDetailsHeading = "Expand all";
    } else {
      this.collapseOrderLineDetailsStatus = false;
      this.expandOrderLineDetailsStatus = true;
      this.setOrderLineDetailsStateOfCollapseAll();
      this.collapseOrderLineDetailsHeading = "Collapse all";
    }
  }

  setOrderLineDetailsStateOfExpandAll() {
    localStorage.setItem("Order-Line-Detail-collapse", "true");
  }

  setOrderLineDetailsStateOfCollapseAll() {
    localStorage.setItem("Order-Line-Detail-collapse", "false");
  }

  getOrderLineDetailsStateOfCollapseAll() {
    const status = localStorage.getItem("Order-Line-Detail-collapse");
    if (status) {
      if (status === "true") {
        this.collapseOrderLineDetailsStatus = true;
        this.expandOrderLineDetailsStatus = false;
        this.collapseOrderLineDetailsHeading = "Expand all";
      } else {
        this.collapseOrderLineDetailsStatus = false;
        this.expandOrderLineDetailsStatus = true;
        this.collapseOrderLineDetailsHeading = "Collapse all";
      }
    }
  }

  onOrderTrackingToggle() {
    if (this.expandOrderTrackingStatus) {
      this.collapseOrderTrackingStatus = true;
      this.expandOrderTrackingStatus = false;
      this.setOrderTrackingStateOfExpandAll();
      this.collapseOrderTrackingHeading = "Expand all";
    } else {
      this.collapseOrderTrackingStatus = false;
      this.expandOrderTrackingStatus = true;
      this.setOrderTrackingStateOfCollapseAll();
      this.collapseOrderTrackingHeading = "Collapse all";
    }
  }

  setOrderTrackingStateOfExpandAll() {
    localStorage.setItem("Order-Tracking-collapse", "true");
  }

  setOrderTrackingStateOfCollapseAll() {
    localStorage.setItem("Order-Tracking-collapse", "false");
  }

  getOrderTrackingStateOfCollapseAll() {
    const status = localStorage.getItem("Order-Tracking-collapse");
    if (status) {
      if (status === "true") {
        this.collapseOrderTrackingStatus = true;
        this.expandOrderTrackingStatus = false;
        this.collapseOrderTrackingHeading = "Expand all";
      } else {
        this.collapseOrderTrackingStatus = false;
        this.expandOrderTrackingStatus = true;
        this.collapseOrderTrackingHeading = "Collapse all";
      }
    }
  }

  onInvoiceEmailToggle() {
    // if (this.expandInvoiceEmailStatus) {
    //   this.collapseInvoiceEmailStatus = true;
    //   this.expandInvoiceEmailStatus = false;
    //   this.setInvoiceEmailStateOfExpandAll();
    //   this.collapseInvoiceEmailHeading = "Expand all";
    // } else {
    //   this.collapseInvoiceEmailStatus = false;
    //   this.expandInvoiceEmailStatus = true;
    //   this.setInvoiceEmailStateOfCollapseAll();
    //   this.collapseInvoiceEmailHeading = "Collapse all";
    // }
  }

  setInvoiceEmailStateOfExpandAll() {
    localStorage.setItem("Invoice-Email-collapse", "true");
  }

  setInvoiceEmailStateOfCollapseAll() {
    localStorage.setItem("Invoice-Email-collapse", "false");
  }

  getInvoiceEmailStateOfCollapseAll() {
    const status = localStorage.getItem("Invoice-Email-collapse");
    if (status) {
      if (status === "true") {
        this.collapseInvoiceEmailStatus = true;
        this.expandInvoiceEmailStatus = false;
        this.collapseInvoiceEmailHeading = "Expand all";
      } else {
        this.collapseInvoiceEmailStatus = false;
        this.expandInvoiceEmailStatus = true;
        this.collapseInvoiceEmailHeading = "Collapse all";
      }
    }
  }

  onPreviewChange(event: boolean) {
    this.showPdfViewer = event;
    this._dataService.setSidebarState(!this.isCollapsed);
  }

  getOrderTrackingDataAgainstSaleOrder(salesId: string, projId: string) {
    this._loaderService.setLoaderState(true);
    if (salesId && projId) {
      this.salesId = salesId;
      this.projId = projId;
      const oDataFilter = `?$top=${this.defaultTracking}&$filter=SalesId eq '${salesId}' and ProjId eq '${projId}'`;
      this._invoicePreviewSummaryService
        .getFreightTrackingLine(oDataFilter)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            res.data.forEach(x => {
              x.PortalKey = uuidv4();
            });

            this.orderTrackingGridListing = res.data;
            this._loaderService.setLoaderState(false);
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  closePrinfPdfModal() {
    this.printPdfModal = false;
  }

  count = 0;
  invoiceEmailAdd() {
    this.cancelAllEditRow();
    this.count++;
    const object = {
      id: 0,
      email: this.copyEmail ?? "",
      name: this.copyName ?? "",
      purpose: this.copyName ? "Invoice" : "",
      save: false,
      exist: false,
      confirmation: false,
      invoice: true,
      salesOrderIdD365: "",
      invoiceEmailRecIdD365: 0,
    } as InvoiceEmail;
    this.invoiceEmailListing.push(object);
    this.invoiceEmail.table.initRowEdit(
      this.invoiceEmail.table.value[this.invoiceEmail.table.value?.length - 1]
    );

    // Means its coming from the COpy BAC or BC checkbox
    // Then save it instead of showing it in editable mode to user
    if (this.copyEmail) {
      this.saveInvoiceEmailModel(object);

      //Make it empty
      this.copyEmail = "";
      this.copyName = "";
    }
  }

  cancelAllEditRow() {
    this.invoiceEmail.table.value.forEach(x => {
      this.invoiceEmail.table.cancelRowEdit(x);
    });
  }

  invoiceEmailDuplicate(invoicedEmail: InvoiceEmail[]): boolean {
    const email = invoicedEmail[invoicedEmail.length - 1]?.email;
    const recid =
      invoicedEmail[invoicedEmail.length - 1]?.invoiceEmailRecIdD365;
    if (!recid) {
      for (const item of this.invoiceEmailListing) {
        if (email === item.email) {
          this._toastrService.error(
            "Error",
            `Email address "${email}". The record already exists.`
          );
          return true;
        }
      }
    }
    return false;
  }

  isEmailInvoiced(invoicedEmail: InvoiceEmail): boolean {
    if (invoicedEmail.invoice) {
      return true;
    }
    return false;
  }

  isEmailValid(invoicedEmail: InvoiceEmail): boolean {
    let isEmail = true;
    const email: string = invoicedEmail.email;
    const regex = `^[a-zA-Z0-9._%+-]+(?:'[a-zA-Z0-9._%+-]+)?@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`;
    if (!RegExp(regex).exec(email)) {
      isEmail = false;
    }
    if (isEmail) {
      return true;
    }
    return false;
  }

  EmailDuplicate(invoicedEmail: InvoiceEmail[]): boolean {
    for (let i = 0; i < invoicedEmail.length; i++) {
      const email = invoicedEmail[i].email;
      for (let j = i + 1; j < invoicedEmail.length; j++) {
        if (email === invoicedEmail[j].email) {
          this._toastrService.error(
            "Error",
            `Email address "${email}". The record already exists.`
          );
          return true;
        }
      }
    }
    return false;
  }

  saveInvoiceEmailModel(invoicedEmail: InvoiceEmail) {
    if (!this.isEmailInvoiced(invoicedEmail)) {
      this._toastrService.error(
        "Error",
        "Atleast one email should be invoiced"
      );
      return;
    }

    if (!invoicedEmail.email) {
      this._toastrService.error("Error", "Email is required");
      return;
    }

    if (!this.isEmailValid(invoicedEmail)) {
      this._toastrService.error("Error", "Invalid email format");
      return;
    }

    const invoiceEmail = invoicedEmail;
    if (!invoiceEmail.invoiceEmailRecIdD365) {
      invoicedEmail.salesOrderIdD365 = this.saleOrderId;
      invoicedEmail.portalKey = uuidv4();
      const invoiceEmailArray = [];
      invoiceEmailArray.push(invoicedEmail);

      if (this.saleOrderId) {
        this._loaderService.setLoaderState(true);
        this._invoicePreviewSummaryService
          .createInvoiceEmailSaleOrderHeaderData(invoiceEmailArray)
          .pipe(untilDestroyed(this))
          .subscribe({
            next: res => {
              this._loaderService.setLoaderState(false);
              this.getInvoiceEmail(this.saleOrderId);
              if (res?.data?.Status?.toLowerCase() === "success") {
                this._toastrService.success(
                  "Success",
                  res.message || "Invoice email create successfully"
                );
              } else {
                this._toastrService.error(
                  "Error",
                  res.message || "Error creating invoice email"
                );
              }
            },
            error: res => {
              this._loaderService.setLoaderState(false);
              this._toastrService.error(
                "Error",
                res.message || "Error creating invoice email"
              );
            },
          });
      }
    } else {
      invoicedEmail.salesOrderIdD365 = this.saleOrderId;
      invoicedEmail.portalKey = "";
      const invoiceEmailArray = [];
      invoiceEmailArray.push(invoicedEmail);
      if (this.saleOrderId) {
        this._loaderService.setLoaderState(true);
        this._invoicePreviewSummaryService
          .updateInvoiceEmailSaleOrderHeaderData(invoiceEmailArray)
          .pipe(untilDestroyed(this))
          .subscribe({
            next: res => {
              this.getInvoiceEmail(this.saleOrderId);
              this._loaderService.setLoaderState(false);
              if (res?.data?.Status?.toLowerCase() === "success") {
                this._toastrService.success(
                  "Success",
                  res.message || "Invoice email updated successfully"
                );
              } else {
                this._toastrService.error(
                  "Error",
                  res.message || "Error updating invoice email"
                );
              }
            },
            error: res => {
              this._loaderService.setLoaderState(false);
              this._toastrService.error(
                "Error",
                res.message || "Error updating invoice email"
              );
            },
          });
      }
    }
  }

  invoiceEmailDelete(invoicedEmail: InvoiceEmail[]) {
    this._loaderService.setLoaderState(true);
    const arrayobject: number[] = [];
    invoicedEmail?.forEach(x => {
      if (x.invoiceEmailRecIdD365 !== 0) {
        arrayobject.push(x.id);
      }
    });
    this._invoicePreviewSummaryService
      .deleteInvoiceEmailData(arrayobject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          this.getInvoiceEmail(this.saleOrderId);
          if (res?.data?.Status?.toLowerCase() === "success") {
            this._toastrService.success(
              "Success",
              res.message || "Invoice email delete successfully"
            );
          } else {
            this._toastrService.error(
              "Error",
              res.message || "Error deleting invoice email"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastrService.error(
            "Error",
            res.message || "Error deleting invoice email"
          );
        },
      });
  }

  invoiceEmailEdit(invoiceEmail: InvoiceEmail) {
    this.cancelAllEditRow();
    const row = this.invoiceEmail.table.value.filter(
      x => x.id === invoiceEmail.id
    );
    if (row.length > 0) {
      this.invoiceEmail.table.initRowEdit(row[0]);
    }
  }

  displaySidebar = false;

  openSideBarForOrderNotes() {
    this.displaySidebar = true;
    this.ordernotessidebar.getAllLinePoNumber(this.saleOrderId);
    this.ordernotessidebar?.clearOrderNoteForm();
  }

  updateSideBarForOrderNotes() {
    this.ordernotes.updateSingleLine();
    this.ordernotessidebar.getAllLinePoNumber(this.saleOrderId);
  }

  deleteSideBarForOrderNotes() {
    this.ordernotes.deleteSaleOrderNotes();
  }

  closeSideBarForOrderNotes() {
    this.displaySidebar = false;
    this.displaySideBeforeSubmittingStatus = false;
  }

  updateLineOnSideBar(selectedOrderNotesGridListing: OrderNotes[]) {
    if (selectedOrderNotesGridListing?.length > 0) {
      this.displaySidebar = true;
      this.ordernotessidebar?.patchValueInOrderNote(
        selectedOrderNotesGridListing[0] as unknown as SalesOrderNotes
      );
    }
  }

  onQuickQuote() {
    this._loaderService.setLoaderState(true);

    const saleOrderFormObject = {
      description: "IP-Note",
      id: 0,
      note: this.quickQuote,
      portalKey: "",
      purchaseOrderStatus: false,
      salesOrderId: "",
      type: "Billing note",
    } as SalesOrderNotes;

    if (this.saleOrderId) {
      saleOrderFormObject.salesOrderId = this.saleOrderId;
      saleOrderFormObject.portalKey = uuidv4();
    }

    this._invoicePreviewSummaryService
      .AddSalesOrderNotes(saleOrderFormObject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this._loaderService.setLoaderState(false);
          this.getSalesOrderNotes(this.saleOrderId);
          this.quickQuote = "";
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastrService.error(
            "Error",
            res.message || "Error adding order note"
          );
        },
      });
  }

  getMyProfile() {
    this._invoicePreviewSummaryService
      .GetMyProfile()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.status.toLowerCase() == "success") {
            this.userInfo = res.data;
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getBillingDetailsForEmails(proposalId: string) {
    this._invoicePreviewSummaryService
      .getBillingDetailsForEmails(proposalId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.status.toLowerCase() == "success") {
            this.billingDetailsForEmails = res.data;
            this.sendApprovalStatusEmail(this.billingDetailsForEmails);
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastrService.error(
            "Error",
            res.message || "Error adding order note"
          );
        },
      });
  }

  sendApprovalStatusEmail(details: GetBillingDetailsForEmailsDto) {
    const toRecipients: MicrosoftGraph.Recipient[] = [
      {
        emailAddress: {
          address: details.billerEmail,
          name: details.billerEmail,
        },
      },
    ];

    if (this.copyBacEmail) {
      const obj: MicrosoftGraph.Recipient = {
        emailAddress: {
          address: this.copyBacEmail,
          name: this.copyBacEmail,
        },
      };
      toRecipients.push(obj);
    }

    if (this.copyBcEmail) {
      const obj: MicrosoftGraph.Recipient = {
        emailAddress: {
          address: this.copyBcEmail,
          name: this.copyBcEmail,
        },
      };
      toRecipients.push(obj);
    }

    const sender: MicrosoftGraph.Recipient = {
      emailAddress: {
        address: this.userInfo.sendEmailAs,
        name: this.userInfo.displayEmailAs,
      },
    };

    let mailMessage: MicrosoftGraph.Message = {};

    mailMessage = {
      subject: details.subject,
      body: {
        contentType: "html",
        content: details.html,
      },
      toRecipients: toRecipients,
      sender: sender,
    };

    const mail = {
      message: mailMessage,
    };
    this._msalApisService.sendMail(mail).subscribe({
      next: () => {
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  sendApprovalStatusEmailIfApproved(
    details: UpdateProjectInvoicePreviewStatusResponseDto
  ) {
    const toRecipients: MicrosoftGraph.Recipient[] = [
      {
        emailAddress: {
          address: details.ipCreatedByEmail,
          name: details.ipCreatedByEmail,
        },
      },
    ];

    // if (this.copyBacEmail) {
    //   const obj: MicrosoftGraph.Recipient = {
    //     emailAddress: {
    //       address: this.copyBacEmail,
    //       name: this.copyBacEmail
    //     }
    //   };
    //   toRecipients.push(obj);
    // }

    // if (this.copyBcEmail) {
    //   const obj: MicrosoftGraph.Recipient = {
    //     emailAddress: {
    //       address: this.copyBcEmail,
    //       name: this.copyBcEmail
    //     }
    //   };
    //   toRecipients.push(obj);
    // }

    // const sender: MicrosoftGraph.Recipient = {
    //   emailAddress: {
    //     address: details.loggedInAdEmail,
    //     name: details.loggedInAdEmail
    //   }
    // };

    let mailMessage: MicrosoftGraph.Message = {};

    mailMessage = {
      subject: details.emailSubject,
      body: {
        contentType: "html",
        content: details.emailTemplate,
      },
      toRecipients: toRecipients,
      //sender: sender
    };

    const mail = {
      message: mailMessage,
    };
    this._msalApisService.sendMail(mail).subscribe({
      next: () => {
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  addScollHiddenClass() {
    if (this.invoicePreviewModalStatus) {
      this.renderer.addClass(document.body, "p-overflow-hidden");
    }
  }

  sellAllOrderTracking() {
    this.orderTrackingModalStatus = true;
  }

  closeModalForOrderTracking() {
    this.orderTrackingModalStatus = false;
  }

  sellAllOrderLineDetails() {
    this.showLessOrderLinesSection = true;
    this.orderLineDetailsGridListing = this.orderLineDetailsGridListingAllData;
    this.orderLineDetailsGridListingFilters =
      this.orderLineDetailsGridListingAllData;
    this.includeNetOnlyLines({ checked: this.includeNetOnlyToggle });
  }

  showLessOrderLines() {
    this.showLessOrderLinesSection = false;
    this.orderLineDetailsGridListing =
      this.orderLineDetailsGridListingAllData.slice(0, 12);
    this.orderLineDetailsGridListingFilters = this.orderLineDetailsGridListing;
    this.includeNetOnlyLines({ checked: this.includeNetOnlyToggle });
  }

  closeModalForOrderLineDetails() {
    this.orderLinesDetailModalStatus = false;
  }

  includeNetOnlyLines(obj: CheckboxChangeEvent) {
    if (obj?.checked) {
      this.includeNetOnlyToggle = true;
      this.orderLineDetailsGridListing =
        this.orderLineDetailsGridListingFilters.filter(x => x.sale >= 0);

      if (this.orderLineDetailsGridListing.length <= 0) {
        this.orderLineDetailsConsumesMessage = "No order line found.";
      }
    } else {
      this.orderLineDetailsGridListing =
        this.orderLineDetailsGridListingFilters.filter(x => x.sale > 0);
      if (this.orderLineDetailsGridListing.length <= 0) {
        this.orderLineDetailsConsumesMessage = "No order line found.";
      }
      this.includeNetOnlyToggle = false;
    }
  }

  redirectToFreightChargesPage() {
    this.freightChargesDisplayModal = true;
  }

  closeModalForFreight() {
    this.freightChargesDisplayModal = false;
  }

  invoiceEmailCopyBacEmailEvent(email: string) {
    this.copyBacEmail = email;
  }

  invoiceEmailCopyBcEmailEvent(email: string) {
    this.copyBcEmail = email;
  }

  invoiceEmailAddBcBacEmailEvent(data: {email: string, name: string}) {
    if (data?.email) {
      this.copyEmail = data.email;
      this.copyName = data.name || "";
    }
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
